<template>
    <div class="tooltip-container">
        <img src="../assets/Info.png" :width="width" :title="tooltip" alt="">
    </div>
</template>

<script>
export default {
    name: "STooltip",

    components: {
    
    },

    data() {
        return {

        };
    },

    props:{
        tooltip:{
            type:String,
            default:"Tooltip"
        },
        width:{
            type:String,
            default:'16px'
        }
    },

    methods: {

    },

    created() {

    },

    validations: function() {
        return {

        };
    },

    computed: {

    }

};
</script>

<style lang="scss" scoped>
.tooltip-container{
    display: inline;
}
</style>